<template>
  <div class="shop-home">
    <div class="top">
      <template v-if="is_login && userInfo.code === uid">
        <div class="top-container">
          <div class="left">
            <div class="info-container">
              <img :src="profile.avatar | default_avatar" alt="" class="avatar">
              <div class="info">
                <div class="name">{{ profile.nickname || profile.username }}</div>
                <div class="count-box">
                  <div class="count-item">{{ profile.total_product_count }} design works</div>
                  <div class="count-item">{{ profile.product_view_times }} views</div>
                </div>
              </div>
            </div>
            <div class="btn-box">
              <div class="btn-items" @click="$router.push({name:'WorkBenchMyTemplate'})">
                <img src="../../assets/images/icon-listing-clothing.png" alt="" class="btn-icon">
                <div class="btn-text">List clothing</div>
              </div>
              <div class="btn-items" @click="$router.push({name:'ShopManage',query:{uid}})">
                <img src="../../assets/images/icon-manage-products.png" alt="" class="btn-icon">
                <div class="btn-text">Manage products</div>
              </div>
              <div class="btn-items" @click="onShareShop">
                <img src="../../assets/images/icon-share-shop.png" alt="" class="btn-icon">
                <div class="btn-text">Share Store</div>
              </div>
            </div>
          </div>
          <div class="right">
            <input 
              type="file" 
              ref="fileInput" 
              @change="handleUpload" 
              style="display: none;" 
              accept="image/*"
            />
            <img src="../../assets/images/icon-edit.png" alt="" class="edit-btn"  @click="triggerUpload">
            <img :src="profile.shop_banner || require('../../assets/images/shop-brand-bg.png')" alt="" class="shop-brand">
          </div>
        </div>
      </template>
      <template v-else>
        <div class="top-custom">
          <div class="left">
            <img :src="profile.shop_banner || require('../../assets/images/shop-brand-bg.png')" alt="" class="shop-brand-bg">
          </div>
          <div class="shop-info">
            <img :src="profile.avatar | default_avatar" alt="" class="avatar">
            <div class="name">{{ profile.nickname || profile.username }}</div>
            <div class="count-box">
              <div class="count-item">{{ profile.total_product_count }} design works</div>
              <div class="count-item">{{ profile.product_view_times }} views</div>
            </div>
            <div class="share-btn" @click="onShareShop">
              <img src="../../assets/images/icon-share-new-black.png" alt="" class="icon">
              <div class="text">Share Store</div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="menu">
      <div class="menu-wrapper">
        <div
          v-for="(item, index) in category_list"
          class="menu-item"
          :class="{ active: item.product_category_id === current_category_id }"
          :key="index"
          @click="change_category(item.product_category_id)"
        >
          {{ item.category_name_en }}<span>({{ item.count }})</span>
        </div>
      </div>
      <div class="search-box">
        <input placeholder="Enter keywords to search" v-model="form_data.keyword" @keyup.enter="onSearch" />
        <img class="search-btn" @click="onSearch" src="../../assets/images/icon-search-new.png" />
      </div>
    </div>
    <div class="list-box">
      <!-- <Poptip triger="hover" placement="bottom" width="130">
        <template #content>

        </template>
        <div class="list-sort"><span>Sort</span> Recently Updated <Icon type="ios-arrow-down"></Icon></div>
      </Poptip> -->
      <div class="list-wrapper">
        <div class="list">
          <div
            class="item"
            v-for="(v, k) in product_list"
            :key="`d` + k"
            @click="edit(v.uuid)"
          >
            <img :src="v.image | default_img" alt="" class="image" />
            <div class="name">{{ v.name }}</div>
            <div class="price">${{ v.factory_price || 0 }}</div>
            <!-- <div class="category">Category: {{ v.product_category_name }}</div>
            <div class="desc">Description: {{ v.description }}</div> -->
            <!-- <div class="time"><span>{{ v.update_time | duration_text }}</span></div> -->
            <!-- <div class="line"></div> -->
            <!-- <div class="mask">
              <div class="icon-list">
                <div class="icon-edit-box" @click.stop="onShareProductClick(v.uuid)">
                    <img
                    src="../../assets/images/icon-share-list-shop-index.png"
                    alt="Share"
                    class="icon-edit"
                    />
                    Share
                </div>
                <Poptip v-if="is_login && userInfo.code == uid" trigger="hover" placement="bottom-start" width="130">
                    <template #content>
                        <div class="menu-box">
                            <div class="menu-item" @click.stop="edit(v.uuid)">Edit</div>
                            <div class="menu-item" @click.stop="unsale(v.uuid)">Unlist</div>
                        </div>
                    </template>
                    <div class="btn-more">
                        <img src="../../assets/images/icon-more-list-shop-index.png" />
                    </div>
                </Poptip>
                <div
                  class="icon-unsale"
                  @click.prevent.stop="unsale(v.uuid)"
                  v-if="v.status == '1'"
                >
                  <img
                    src="../../assets/images/icon-unsale.png"
                    alt="Unlist"
                    class="ico"
                  />
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="page-container">
            <Page :total="total_count" prev-text="Previous" next-text="Next" @on-change="onPageChange"></Page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {
  SaveProfile,
  ProfileNoAuth,
  ProductList,
  UserProductCategoryList,
  ProductUnsale,
} from "@/api/index.js";
import { mapState } from "vuex";
import { uploadFileToOSS } from "@/utils/oss";
export default {
  data() {
    return {
      uid: "",
      profile: {},
      form_data: {
        keyword: "",
        product_category_id: 0,
        page:1,
        limit:15,
        status:99
      },
      current_category_id: 0,
      product_list: [],
      category_list: [],
      total_count:0
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    is_login(){
      return this.$store.state.is_login;
    }
  },
  watch: {
    current_category_id(newVal, oldVal) {
      this.form_data.product_category_id = newVal;
      this.getProductList();
    },
  },
  mounted() {
    this.uid = this.$route.query.uid;
    axios
      .all([
        this.getProfile(),
        this.getProductCategoryList(),
        this.getProductList(),
      ])
      .then(axios.spread(() => {}));
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$emit('changeFooter', 'light');
    });
  },
  methods: {
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    async handleUpload(event, field) {
      try {
        const file = event.target.files[0];
        if (!file) return;
        const url = await uploadFileToOSS(file, 'template');
        this.shop_banner = url;
        await SaveProfile({ shop_banner:url})
        this.$layer.msg('Upload Success!');
        this.getProfile();
      } catch (err) {
        this.$layer.msg('上传失败：' + err.message);
      }
    },
    onPageChange(e){
        this.form_data.page = e;
        this.getProductList();
    },
    onSearch(){
        this.getProductList();
    },
    async onShareShop(){
        const {uid} = this;
        const uri = `${window.location.origin}/shop/home?uid=${uid}`;
        await navigator.clipboard.writeText(uri);
        this.$layer.msg('Copy successful');
    },
    async onShareProductClick(uuid){
        const uri = `${window.location.origin}/shop/product/detail?uuid=${uuid}`;
        await navigator.clipboard.writeText(uri);
        this.$layer.msg('Copy successful');
    },
    async unsale(uuid) {
      console.log("uuid", uuid);
      const { code, msg } = await ProductUnsale({ uuid });
      if (code == "0") {
        this.$layer.msg(msg);
        this.getProductCategoryList();
        this.getProductList();
        return;
      }
    },
    change_category(s) {
      this.current_category_id = s;
    },
    edit(uuid) {
      console.log(111, this.userInfo);
      if (this.userInfo.id > 0 && this.userInfo.code === this.uid) {
        this.$router.push({ name: "ProductEdit", query: { uuid } });
      } else {
        this.$router.push({ name: "ProductDetail", query: { uuid } });
      }
    },
    async getProductCategoryList() {
      return UserProductCategoryList({
        code: this.uid,
        ...this.form_data,
      }).then((response) => {
        this.category_list = [...response.data];
        let count = this.category_list
          .map((v) => v.count)
          .reduce((a, b) => a + b, 0);
        this.category_list = [
          { category_name_en: "All", product_category_id: 0, count },
          ...response.data,
        ];
        return response;
      });
    },
    async getProfile() {
      return ProfileNoAuth({ code: this.uid }).then((response) => {
        this.profile = response.data;
        return response;
      });
    },
    async getProductList() {
        console.log({
        ...this.form_data,
        code: this.uid,
        // status: this.userInfo.code !== this.uid ? 1 : 0,
      });
      return ProductList({
        ...this.form_data,
        code: this.uid,
        status: this.userInfo.code !== this.uid ? 1 : 99,
      }).then((response) => {
        this.product_list = response.data;
        this.total_count = response.data.length;
        return this.getProductCategoryList();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./home.scss";
</style>